import { Component, Input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { WfdPriorityType } from '../../enums/wfd-priority.enum';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { Owner } from 'src/app/shared/helpers/owner.decorator';

@Owner('Stat-Force 1')
@Component({
    selector: 'nova-wfd-vip-chip',
    standalone: true,
    imports: [MatChipsModule, MatIconModule, MatTooltipModule, NgClass],
    template: `
        <mat-chip
            [ngClass]="isCompact ? 'compact' : ''"
            color="info"
            data-qa-id="wfd-vip-priority-chip"
            [disabled]="isDisabled"
            [matTooltipHideDelay]="hideDelay"
            [matTooltip]="tooltipText"
            [matTooltipDisabled]="tooltipDisabled"
            matTooltipPosition="above">
            <mat-icon matChipAvatar>verified_user</mat-icon>
            {{ WfdPriorityType.Vip }}
        </mat-chip>
    `,
    styleUrls: ['./chip.component.scss']
})
export class WfdVipChipComponent {
    @Input() isDisabled = false;
    @Input() isCompact = false;
    @Input() tooltipText = 'Client-requested candidate that must be booked';
    @Input() tooltipDisabled = false;
    @Input() hideDelay = 500;

    WfdPriorityType = WfdPriorityType;
}
